import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, H2 } from "../shared";
import { boni } from "../content";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../../ui/accordion";

export default function BoniSection() {
  return (
    <Section id="boni" testId="boni-section" className="py-24 md:py-36">
      <SectionLabel testId="boni-label">Inklusive</SectionLabel>
      <Reveal>
        <h2 className={`${H2} mb-14 max-w-3xl text-3xl md:text-5xl`}>Weitere Boni für Dich.</h2>
      </Reveal>
      <Reveal delay={0.06}>
        <Accordion type="single" collapsible className="w-full">
          {boni.map((b, i) => (
            <AccordionItem key={b.title} value={`bonus-${i}`} className="border-t border-cognac/30 border-b-0" data-testid={`bonus-item-${i}`}>
              <AccordionTrigger data-testid={`bonus-trigger-${i}`} className="min-w-0 gap-6 py-7 text-left hover:no-underline [&>svg]:shrink-0 [&>svg]:text-cognac-2">
                <span className="flex min-w-0 flex-1 items-start gap-5">
                  <span className="font-heading text-lg font-700 text-cognac-2" style={{ fontWeight: 700 }}>
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="min-w-0">
                    <span className="block hyphens-auto break-words font-heading text-xl font-700 uppercase leading-snug tracking-tight text-espresso md:text-2xl" style={{ fontWeight: 700 }} lang="de">
                      {b.title}{" "}
                      <span className="font-600 text-cognac-2" style={{ fontWeight: 600 }}>(Wert: {b.wert})</span>
                    </span>
                    <span className="mt-2 block font-body text-base leading-[1.7] text-[#241a15]/85 md:text-lg" style={{ fontWeight: 300 }}>
                      {b.teaser}
                    </span>
                  </span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="pb-10 md:pl-12">
                <div className="max-w-3xl space-y-4">
                  {b.intro.map((p) => (
                    <p key={p} className="font-body text-base leading-[1.75] text-[#241a15] md:text-lg">{p}</p>
                  ))}
                  <p className="pt-2 font-heading text-sm font-700 uppercase tracking-[0.2em] text-cognac-2" style={{ fontWeight: 700 }}>
                    {b.listTitle}
                  </p>
                  <ul className="grid gap-4 md:grid-cols-2">
                    {b.list.map((l, j) => (
                      <motion.li
                        key={l}
                        initial={{ opacity: 0, y: 28, rotate: j % 2 ? 5 : -5 }}
                        animate={{ opacity: 1, y: 0, rotate: j % 2 ? 0.7 : -0.7 }}
                        transition={{ delay: 0.1 + j * 0.09, duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                        style={{ transformOrigin: "bottom left" }}
                        className="flex gap-3 rounded-sm border border-cognac/40 bg-white/50 p-5 shadow-[0_14px_30px_-20px_rgba(62,39,35,0.5)]"
                      >
                        <Check className="mt-1 h-5 w-5 shrink-0 text-cognac-2" />
                        <p className="font-body text-base leading-[1.7] text-[#241a15] md:text-lg">{l}</p>
                      </motion.li>
                    ))}
                  </ul>
                  {b.outro && <p className="pt-2 font-body text-base italic leading-[1.7] text-cognac-2 md:text-lg">{b.outro}</p>}
                </div>
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
      <Reveal delay={0.1}>
        <p className="mt-12 font-heading text-xl font-700 uppercase tracking-tight text-espresso md:text-2xl" style={{ fontWeight: 700 }} data-testid="boni-total">
          Gesamtwert der Boni: 1.975 € – für Dich inklusive!
        </p>
      </Reveal>
    </Section>
  );
}
